import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import DigitalPrev from '../views/apps/DigitalPrev.vue'
import SGM from '../views/apps/SGM.vue'
import Fopag from '../views/apps/Fopag.vue'
import FlowDocs from '../views/apps/FlowDocs.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/DigitalPrev',
    name: 'DigitalPrev',
    component: DigitalPrev
  },
  {
    path: '/SGM',
    name: 'SGM',
    component: SGM
  },
  {
    path: '/Fopag',
    name: 'Fopag',
    component: Fopag
  },
  {
    path: '/FlowDocs',
    name: 'FlowDocs',
    component: FlowDocs
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
